<template>
  <div id="digital-window" class="digital-window" :style="{ top: top + 'px', bottom: bottom + 'px', left: left + 'px', right: right + 'px' }">
    <div id="digital-page" class="page">
      <!-- 当前页面图片 -->
      <div class="image" v-if="page" v-show="loaded">
        <img id="digital-image" :src="page.image" onselectstart="return false" ondragstart="return false" />
      </div>
      <!-- 音频和视频图标的外部区域的大小，这个大小最好能够在缩放后保持与PC端的图标大小32PX接近为好 -->
      <div id="digital-res-node-none" class="res-node none" :style="{ top: '-10000px', left: '-10000px' }"></div>
      <div
        v-for="(coord, coordindex) in coordinates"
        v-bind:key="coordindex + 100 + 'coordindex'"
        class="res-node area"
        :data-index="coordindex"
        :data-type="coord.type"
        :style="{ top: coord.topScale + 'px', left: coord.leftScale + 'px', width: coord.widthScale + 'px', height: coord.heightScale + 'px', zIndex: coord.zIndex }"
        @click="areaClick($event, coord)"
      >
        <div :key="'div-resize' + i" v-for="i in 8" :class="['resize', 'resize' + i]" @mousedown="resizePageElement($event, i, coord)"></div>
        <div class="z-index_view" v-if="coord == editCoord">
          <div class="z-index-buttons">
            <img src="@imgs/digital/zIndex-top.png" @click="changLayout($event, coordindex, 'top')" />
            <img src="@imgs/digital/zIndex-up.png" @click="changLayout($event, coordindex, 'up')" />
            <img src="@imgs/digital/zIndex-down.png" @click="changLayout($event, coordindex, 'down')" />
            <img src="@imgs/digital/zIndex-bottom.png" @click="changLayout($event, coordindex, 'bottom')" />
          </div>
          <div class="view">
            <img
              :class="{ current: coordinates.length - i === coord.zIndex }"
              :src="coordinates.length - i === coord.zIndex ? require('@imgs/digital/zIndex1.png') : require('@imgs/digital/zIndex0.png')"
              :key="'z-index' + i"
              v-for="i in coordinates.length"
            />
          </div>
        </div>
      </div>
      <!-- 页面资源元素（通过JS插入） -->
    </div>
    <div class="tools" v-if="edit">
      <div class="box">
        <div
          class="btn article"
          @click="selectTool($event, 'area', false)"
          @dblclick="selectTool($event, 'area', true)"
          :class="{ selected: addArticleStatus, continuity: addArticleStatus && addContinuityStatus }"
        >
          <img src="@imgs/digital/article-btn.png" alt="" draggable="false" />
        </div>
        <div
          class="btn picture"
          @click="selectTool($event, 'picture', false)"
          @dblclick="selectTool($event, 'picture', true)"
          :class="{ selected: addPictureStatus, continuity: addPictureStatus && addContinuityStatus }"
        >
          <img src="@imgs/digital/picture-btn.png" alt="" draggable="false" />
        </div>
        <div
          class="btn audio"
          @click="selectTool($event, 'audio', false)"
          @dblclick="selectTool($event, 'audio', true)"
          :class="{ selected: addAudioStatus, continuity: addAudioStatus && addContinuityStatus }"
        >
          <img src="@imgs/digital/audio-btn.png" alt="" draggable="false" />
        </div>
        <el-tooltip popper-class="video-wrapper" placement="left">
          <div slot="content" class="video-btn-wrapper">
            <div @click="selectTool($event, 'innerVideo', false)" @dblclick="selectTool($event, 'video', true)">嵌入式视频</div>
            <div @click="selectTool($event, 'video', false)" @dblclick="selectTool($event, 'video', true)">弹出式视频</div>
          </div>
          <div class="btn video" :class="{ selected: addVideoStatus, continuity: addVideoStatus && addContinuityStatus }"><img src="@imgs/digital/video-btn.png" alt="" draggable="false" /></div>
        </el-tooltip>
        <div
          class="btn link"
          @click="selectTool($event, 'link', false)"
          @dblclick="selectTool($event, 'link', true)"
          :class="{ selected: addLinkStatus, continuity: addLinkStatus && addContinuityStatus }"
        >
          <img src="@imgs/digital/link-btn.png" alt="" draggable="false" />
        </div>
        <div class="btn remove" @click="removePageSelectedElement" :class="{ actived: pageSelectedElement !== null }">
          <img src="@imgs/digital/remove-btn.png" alt="" />
        </div>
      </div>
    </div>
    <digital-upload-image
      ref="digitalUploadImage"
      @updateImageState="updateImageState"
      @updateImageSuccess="updateImageSuccess"
      @updateImageComplete="updateImageComplete"
      @updateImageError="updateImageError"
    ></digital-upload-image>
    <div class="edit-audio" id="edit-audio" @click="editAudioClick" v-if="edit">
      <div class="title">
        <div class="text">音频设置</div>
        <div class="close" @click="editAudioCancel"><img src="@imgs/digital/close-black.png" /></div>
      </div>
      <div class="box" v-if="editConfig">
        <div class="line">上传音频</div>
        <div class="line">
          <DigitalUploadAudio
            ref="digitalUploadAudio"
            @updateAudioState="updateAudioState"
            @updateAudioProgress="updateAudioProgress"
            @updateAudioSuccess="updateAudioSuccess"
            @updateAudioComplete="updateAudioComplete"
          >
          </DigitalUploadAudio>
          <input class="filename" v-model="editConfig.file" readonly />
          <el-button class="uploadbtn" size="mini" @click="digitalUploadAudio">
            <span v-if="uploadAudioStatus">{{ uploadAudioProgress }}%</span>
            <span v-else>上传</span>
          </el-button>
        </div>
        <div class="line">
          <span>播放控制：</span>
          <el-radio-group v-model="editConfig.controls" @change="editConfig.controls === false ? (editConfig.autoplay = true) : ''">
            <el-radio :label="true" style="margin-right: 15px;">显示</el-radio>
            <el-radio :label="false">不显示</el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <span>自动播放：</span>
          <el-radio-group v-model="editConfig.autoplay" :disabled="editConfig.controls === false">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否 </el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <span>循环播放：</span>
          <el-radio-group v-model="editConfig.loopplay">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
        <div class="line loadPic">
          <span>按钮图片：</span>
          <div class="right">
            <div class="loadingSelect">
              <el-radio-group v-model="editConfig.btnStyle">
                <el-radio :label="0" style="margin-right: 15px;">默认</el-radio>
                <el-radio :label="1">自定义</el-radio>
              </el-radio-group>
            </div>
            <digital-custom-img
              v-show="editConfig.btnStyle"
              classify-manage="hotspot_audio_icon"
              :edit-config="editConfig"
              @del-config="delConfig"
              @update-obj="updateObjFn"
              @add-icon="addConfigFn"
              ref="digitalAudioCustomImgRef"
            />
          </div>
        </div>
        <div class="line line-button">
          <button class="cancel" @click="editAudioCancel">取消</button>
          <button class="submit" @click="editAudioSubmit">确定</button>
        </div>
      </div>
    </div>
    <div class="edit-video" id="edit-video" @click="editVideoClick" v-if="edit">
      <div class="title">
        <div class="text">视频设置</div>
        <div class="close" @click="editVideoCancel"><img src="@imgs/digital/close-black.png" /></div>
      </div>
      <div class="box" v-if="editConfig">
        <div class="line">上传视频</div>
        <div class="line">
          <DigitalUploadVideoTc
            ref="digitalUploadVideoTc"
            :maxSize="maxSize"
            :sizeTip="sizeTip"
            :maxSpace="maxSpace"
            typeTip="请上传H264标准的mp4文件"
            accept="video/mp4"
            @updateState="updateVideoTcState"
            @uploadSuccess="uploadVideoTcSuccess"
            @uploadError="uploadVideoTcError"
            @updatePercentage="updateVideoTcPercentage"
            @toSpace="updateVideoTcToSpace"
          ></DigitalUploadVideoTc>
          <input class="filename" v-model="editConfig.file" />
          <el-button class="uploadbtn" size="mini" @click="digitalUploadVideo">
            <span v-if="uploadVideoStatus">{{ uploadVideoProgress }}%</span>
            <span v-else>上传</span>
          </el-button>
        </div>
        <div class="line">
          <span>播放控制：</span>
          <el-radio-group v-model="editConfig.controls" @change="editConfig.controls === false ? (editConfig.autoplay = true) : ''">
            <el-radio :label="true" style="margin-right: 15px;">显示</el-radio>
            <el-radio :label="false">不显示</el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <span>自动播放：</span>
          <el-radio-group v-model="editConfig.autoplay" :disabled="editConfig.controls === false">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否 </el-radio>
          </el-radio-group>
        </div>
        <div class="line">
          <span>循环播放：</span>
          <el-radio-group v-model="editConfig.loopplay">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
        <div class="line loadPic">
          <span>{{ editRes.type === 'video' ? '按钮' : '封面' }}图片：</span>
          <div class="right">
            <div class="loadingSelect">
              <el-radio-group v-model="editConfig.btnStyle">
                <el-radio :label="0" style="margin-right: 15px;">默认</el-radio>
                <el-radio :label="1">自定义</el-radio>
              </el-radio-group>
            </div>
            <digital-custom-img
              v-show="editConfig.btnStyle"
              @del-config="delConfig"
              @add-icon="addConfigFn"
              @update-obj="updateObjFn"
              :edit-config="editConfig"
              :classify-manage="editRes.type === 'video' ? 'hotspot_video_icon' : 'hotspot_video_cover'"
              ref="digitalVideoCustomImgRef"
            />
          </div>
        </div>
        <div class="line line-button">
          <button class="cancel" @click="editVideoCancel">取消</button>
          <button class="submit" @click="editVideoSubmit">确定</button>
        </div>
      </div>
    </div>
    <div class="edit-link" id="edit-link" @click="editLinkClick" v-if="edit">
      <div class="title">
        <div class="text">超链接设置</div>
        <div class="close" @click="editLinkCancel"><img src="@imgs/digital/close-black.png" /></div>
      </div>
      <div class="box" v-if="editConfig">
        <el-radio :label="0" v-model="editConfig.linkType" style="margin-right: 15px;">跳转网页</el-radio>
        <div class="line path" :class="{ 'is-disabled': editConfig.linkType === 1 }">设置链接地址</div>
        <div class="line path" :class="{ 'is-disabled': editConfig.linkType === 1 }">
          <textarea class="href" :disabled="editConfig.linkType === 1" v-model="editConfig.href"></textarea>
        </div>
        <el-radio :label="1" v-model="editConfig.linkType">跳转页面</el-radio>
        <el-radio-group v-model="editConfig.pageS" :disabled="editConfig.linkType === 0">
          <el-radio label="pre">上一页</el-radio>
          <el-radio label="next">下一页</el-radio>
          <el-radio label="first">首页</el-radio>
          <el-radio label="page">指定页面</el-radio>
          <el-input @change="checkInput" :disabled="editConfig.pageS !== 'page' || editConfig.linkType === 0" v-model="editConfig.page" type="Number" size="mini"></el-input>
        </el-radio-group>
        <div class="line loadPic">
          <span>提示图片：</span>
          <div class="right">
            <div class="loadingSelect">
              <el-radio-group v-model="editConfig.btnStyle">
                <el-radio :label="0" style="margin-right: 15px;">默认</el-radio>
                <el-radio :label="1">自定义</el-radio>
              </el-radio-group>
            </div>
            <digital-custom-img
              v-show="editConfig.btnStyle"
              @del-config="delConfig"
              @update-obj="updateObjFn"
              @add-icon="addConfigFn"
              :edit-config="editConfig"
              classify-manage="hotspot_hyperlink_icon"
              ref="digitalCustomImgRef"
            />
          </div>
        </div>
        <div class="line line-button">
          <button class="cancel" @click="editLinkCancel">取消</button>
          <button class="submit" @click="editLinkSubmit">确定</button>
        </div>
      </div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <tip-dialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim" :appendToBody="true"></tip-dialog>
  </div>
</template>
<script>
import DigitalUploadAudio from './DigitalUploadAudio'
import DigitalUploadVideoTc from './DigitalUploadVideoTc'
import DigitalCustomImg from './DigitalCustomImg'
import setBook from '../../api/setBook'
import TipDialog from '@components/common/TipDialog.vue'
import DigitalUploadImage from '@components/digital/DigitalUploadImage'

export default {
  name: 'DigitalPage',
  components: {
    DigitalUploadVideoTc,
    DigitalUploadAudio,
    DigitalCustomImg,
    TipDialog,
    DigitalUploadImage
  },
  props: {
    top: {
      type: [Number, String],
      default: 22
    },
    bottom: {
      type: [Number, String],
      default: 22
    },
    left: {
      type: [Number, String],
      default: 360
    },
    right: {
      type: [Number, String],
      default: 460
    },
    edit: {
      type: Boolean,
      default: true
    },
    pages: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // DOM相关
      eleWindow: null,
      elePage: null,
      eleImage: null,
      eleNone: null,
      eleNoneWidth: 32, // 资源图标的实时尺寸数据
      eleNoneHeight: 32, // 资源图标的实时尺寸数据
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // 外部相关（主要用于对外开放接口）
      digital: null, // 数字对象
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // 页面相关
      page: null, // 当前页面数据
      pageWidth: 0, // 当前页面的实际宽度
      pageHeight: 0, // 当前页面的实际高度
      pageIndex: 0, // 当前页面第几页
      pageScale: 1, // 当前比例
      pageLoading: false, // 当前页面是否正在加载中
      pageSelectedElement: null, // 页面当前选中的元素
      coordinates: [], // 当前页面的热区数据
      editCoord: null,
      pageTime: 0, // 页面加载的时间（主要用于当替换PDF后，由于图片缓存还存在的，导致OSS加载给我的还是以前的图片）
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // 属性相关
      uploadStatus: false, // 用于表示是否正在操作上传功能
      uploadAudioStatus: false, // 上传音频状态《用于判断是否正在上传中》
      uploadAudioProgress: 0,
      uploadVideoStatus: false, // 上传视频的状态《用于判断是否正在上传中》
      uploadImageStatus: false, // 上传图片的状态《用于判断是否正在上传中》
      uploadVideoProgress: 0,
      editConfig: null, // 三个编辑框的当前处理数据，NULL表示当前未打开任何需要编辑属性配置的界面
      editRes: null, // 正在编辑的资源对象，NULL表示当前未打开任何需要编辑属性配置的界面,
      addFileAttachIds: [], // 添加的附件ID
      delFileAttachIds: [], // 删除的附件ID
      delResArray: [], // 删除的资源列表
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // 创建元素相关
      addAudioStatus: false, // 添加音频的状态
      addVideoStatus: false, // 添加视频的状态
      addLinkStatus: false, // 添加链接的状态
      addArticleStatus: false, // 添加文章的状态
      addPictureStatus: false, // 添加图片的状态
      addContinuityStatus: false, // 添加连续状态，用于判断是否支持音频、视频、链接的一次选择多次添加
      deletePic: null,
      updateObj: null,
      addConfig: null,
      eleResNode: null,
      loaded: false,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '当前区域已添加文章，是否删除？'
      }
    }
  },
  watch: {},
  computed: {
    maxSize() {
      return 100
    },
    sizeTip() {
      return `视频大小不能超过100M`
    },
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    },
    totalSpace() {
      return this.$store.state.manage.allSpace
    },
    maxSpace() {
      return this.totalSpace * 1024 - this.alreadyUse
    },
    epaperPub() {
      return this.$store.state.common.vipRight.epaperPub
    },
    epaperRichMedia() {
      return this.$store.state.common.vipRight.epaperRichMedia
    },
    totalPage() {
      return this.$store.state.book.totalPage
    },
    isBook() {
      return this.$route.query.type === 'book'
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  mounted() {
    // 对外接口
    this.digital = {
      // 放大
      enlarge: () => {
        this.enlarge()
      },
      // 缩小
      narrow: () => {
        this.narrow()
      },
      // 切换页面
      changePage: (pageIndex) => {
        this.changePage(pageIndex)
      },
      addFileAttachIds: () => {
        return this.addFileAttachIds
      },
      delFileAttachIds: () => {
        return this.delFileAttachIds
      },
      delResArray: () => {
        return this.delResArray
      },
      clear: () => {
        this.addFileAttachIds = []
        this.delFileAttachIds = []
        this.delResArray = []
      }
    }
    // 初始化
    this.init()
    this.pageTime = new Date().getTime()
  },
  methods: {
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 初始化
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    init() {
      // 获取重要的元素DOM
      this.eleWindow = document.getElementById('digital-window')
      this.elePage = document.getElementById('digital-page')
      this.eleImage = document.getElementById('digital-image')
      // 监控窗口变化，以触发页面自适应功能
      window.onresize = () => {
        if (this.page) {
          this.resizePage()
        }
      }
      // 页面元素支持移动位置功能
      this.movePage()
      // 生命周期回调
      this.$emit('onCreate', this.digital)
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 页面展示
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 让页面可以进行位置移动
     */
    movePage() {
      this.elePage.onmousedown = null
      // 20221219 去掉页面移动的效果
      // this.elePage.onmousedown = (e) => {
      //   let pageX = e.pageX
      //   let pageY = e.pageY
      //   let elePageLeft = parseFloat(this.elePage.style.left)
      //   let elePageTop = parseFloat(this.elePage.style.top)
      //   this.elePage.style.cursor = 'move'
      //   document.onmousemove = (e) => {
      //     this.elePage.style.top = elePageTop + e.pageY - pageY + 'px'
      //     this.elePage.style.left = elePageLeft + e.pageX - pageX + 'px'
      //   }
      //   document.onmouseup = () => {
      //     document.onmousemove = null
      //     document.onmouseup = null
      //     this.elePage.style.cursor = 'default'
      //   }
      // }
    },
    /**
     * 选择页面
     * @param pageIndex 页面索引，从1开始
     */
    changePage(pageIndex) {
      const resizeImageSize = (width, height) => {
        // 加载页面
        this.pageWidth = width
        this.pageHeight = height
        this.pageLoading = false
        this.initResNodes()
        // 重置页面
        setTimeout(() => {
          // 获取None元素
          this.eleNone = document.getElementById('digital-res-node-none')
          this.resizePage()
        }, 100)
      }
      // 判断页面是否超出范围
      this.editCoord = null
      if (pageIndex - 1 < 0 || pageIndex - 1 >= this.pages.length) {
        return
      }
      // 确定当前页面数据
      let page = this.pages[pageIndex - 1]
      if (page) {
        this.pageIndex = pageIndex
        this.pageLoading = true
        // 获取当前页面的图片的尺寸
        let image = new Image()
        image.src = page.image
        this.page = page
        if (page.width && page.height) {
          resizeImageSize(page.width, page.height)
        } else {
          image.onload = () => {
            resizeImageSize(image.width, image.height)
          }
        }
      } else {
        console.log('页面数据丢失')
        console.log('pages', this.pages)
        console.log('pageIndex', pageIndex - 1)
      }
    },
    /**
     * 重置页面及内部元素的尺寸及位置
     */
    resizePage(pageScale) {
      // 获取窗口尺寸
      let eleWindowWidth = this.eleWindow?.offsetWidth
      let eleWindowHeight = this.eleWindow?.offsetHeight
      // 计算比例
      if (pageScale === undefined) {
        this.pageScale = Math.min(eleWindowWidth / this.pageWidth, eleWindowHeight / this.pageHeight)
      } else {
        this.pageScale = pageScale
      }
      // 获取None元素的等比尺寸
      let eleNoneWidth = this.eleNoneWidth / this.pageScale
      let eleNoneHeight = this.eleNoneHeight / this.pageScale
      // 设置页面的尺寸及位置
      let elePageWidth = this.pageWidth * this.pageScale
      let elePageHeight = this.pageHeight * this.pageScale
      this.elePage.style.width = elePageWidth + 'px'
      this.elePage.style.height = elePageHeight + 'px'
      this.elePage.style.top = (eleWindowHeight - elePageHeight) / 2 + 'px'
      this.elePage.style.left = (eleWindowWidth - elePageWidth) / 2 + 'px'
      this.loaded = true
      // 设置页面下面所有资源的尺寸及位置
      for (let a in this.elePage.children) {
        if (this.elePage.children.hasOwnProperty(a)) {
          let ele = this.elePage.children[a]
          if (ele.className.indexOf('res-node') !== -1) {
            // 处理子元素的尺寸和位置
            if (ele.className.indexOf('none') !== -1) {
              // 尺寸元素
              ele.style.width = eleNoneWidth + 'px'
              ele.style.height = eleNoneHeight + 'px'
            } else {
              // 普通元素
              let res = null
              let type = ele.getAttribute('data-type')
              if (type === 'area') {
                res = this.coordinates[ele.getAttribute('data-index')]
              } else {
                res = this.page.resources[ele.getAttribute('data-index')]
              }
              res.widthScale = res.width * this.pageScale
              res.heightScale = res.height * this.pageScale
              res.topScale = res.top * this.pageScale
              res.leftScale = res.left * this.pageScale
              ele.style.width = res.widthScale + 'px'
              ele.style.height = res.heightScale + 'px'
              ele.style.top = res.topScale + 'px'
              ele.style.left = res.leftScale + 'px'
            }
          }
        }
      }
    },
    /**
     * 初始化添加资源节点
     */
    initResNodes() {
      this.coordinates = []
      setTimeout(() => {
        this.coordinates = this.page.coordinates || []
        // 清空当前页面的元素
        for (let a = this.elePage.children.length - 1; a >= 0; a--) {
          let eleResNode = this.elePage.children[a]
          let eleResNodeClassName = eleResNode.className
          if (eleResNodeClassName === 'image' || eleResNodeClassName === 'loading' || eleResNodeClassName === 'res-node none') {
            continue
          }
          this.elePage.removeChild(eleResNode)
        }
        // 添加当前页面的所有元素
        for (let a in this.page.resources) {
          if (this.page.resources.hasOwnProperty(a)) {
            this.resInitScale(this.page.resources[a])
            this.addResNode(a, this.page.resources[a])
          }
        }
      }, 100)
    },
    /**
     * 添加资源节点
     * @param resIndex 资源索引（数组索引）
     * @param res 资源对象 {
     *     id: 0, //资源身份，没有ID时表示新的资源，有ID时表示资源已存在
     *     type: '', // audio,video,link,area
     *     top: 100, // 原始位置
     *     left: 100, // 原始位置
     *     width: 32, // 原始尺寸
     *     height: 32, // 原始尺寸
     *     topScale: 33.44, // 缩放位置
     *     leftScale: 33.44, // 缩放位置
     *     widthScale: 33.44, // 缩放尺寸
     *     heightScale: 33.44, // 缩放尺寸
     *     zindex: 3,
     *     resize: false,
     *     href: '', // link
     *     file: '', // audio,video
     *     fileid: 0, // 附件ID
     *     path: '', // 附件地址
     *     controls: false, // audio,video
     *     autoplay: false, // audio,video
     *     loopplay: false, // audio,video
     *     edit: false // 是否编辑过（添加也属于编辑，至于是添加还是编辑则看id字段）
     * }
     * @returns {HTMLElement}
     */
    addResNode(resIndex, res) {
      let type = res.type
      let zindex = res.zindex
      let eleResNode = document.createElement('DIV')
      eleResNode.setAttribute('data-type', type)
      // 如果不是热区，则创建一个小图标
      if (type !== 'area') {
        let eleImg = document.createElement('IMG')
        if (res.btnPath && res.btnStyle === 1 && type !== 'innerVideo') {
          eleImg.src = res.btnPath
        } else {
          let icon = type === 'innerVideo' ? 'video' : type
          eleImg.src = require('@imgs/digital/' + icon + '.png')
        }
        /*if (type === 'audio') {
          eleImg.src = require('@imgs/digital/audio.png')
        } else if (type === 'video') {
          eleImg.src = require('@imgs/digital/video.png')
        } else if (type === 'link') {
          eleImg.src = require('@imgs/digital/link.png')
        }*/
        eleImg.onselectstart = function() {
          return false
        }
        eleImg.ondragstart = function() {
          return false
        }
        if (type === 'picture') {
          eleResNode.style.backgroundImage = `url(${res.path})`
        }
        if (type === 'innerVideo') {
          let eleSource = document.createElement('SOURCE')
          let eleVideo = document.createElement('VIDEO')
          eleSource.src = res.path
          eleSource.type = 'video/mp4'
          eleVideo.style = 'width:100%;height:100%;'
          if (res.btnPath && res.btnStyle === 1) {
            eleVideo.poster = res.btnPath
          }
          eleVideo.appendChild(eleSource)
          eleResNode.append(eleVideo)
        }
        if (this.edit) {
          // 编辑状态，则图标支持点击打开编辑属性界面
          eleImg.ondblclick = (e) => {
            if (type === 'audio') {
              this.editAudio(e, res)
            } else if (type === 'video' || type === 'innerVideo') {
              this.editVideo(e, res)
            } else if (type === 'link') {
              this.editLink(e, res)
            } else if (type === 'picture') {
              this.uploadImg(res)
            }
          }
        } else {
          if (type === 'audio') {
            eleImg.onclick = () => {
              alert('open audio play')
            }
          } else if (type === 'video') {
            eleImg.onclick = () => {
              alert('open video play')
            }
          }
        }
        // 添加元素
        eleResNode.appendChild(eleImg)
      }
      if (this.edit) {
        // 如果是热区和链接，则需要创建调整大小的8个小元素
        if (type === 'area' || type === 'link' || type === 'picture' || type === 'innerVideo') {
          for (let i = 1; i <= 8; i++) {
            let eleResize = document.createElement('DIV')
            eleResize.className = 'resize resize' + i
            eleResize.onmousedown = (e) => {
              this.resizePageElement(e, i, res)
            }
            eleResNode.appendChild(eleResize)
          }
        }
        // 编辑状态，则支持选中元素、移动元素操作
        eleResNode.onclick = (e) => {
          this.selectedPageElement(e)
        }
        eleResNode.onmousedown = (e) => {
          this.movePageElement(e, res)
        }
      } else {
        if (type === 'area' || type === 'link') {
          eleResNode.onclick = () => {
            window.open(res.href)
          }
        }
      }
      // 处理元素的外层DIV
      eleResNode.className = 'res-node ' + type
      eleResNode.style.top = res.topScale + 'px'
      eleResNode.style.left = res.leftScale + 'px'
      eleResNode.style.width = res.widthScale + 'px'
      eleResNode.style.height = res.heightScale + 'px'
      eleResNode.style.zIndex = zindex + 10
      eleResNode.setAttribute('data-index', resIndex)
      eleResNode.onselectstart = function() {
        return false
      }
      eleResNode.ondragstart = function() {
        return false
      }
      this.elePage.appendChild(eleResNode)
      return eleResNode
    },
    /**
     * 放大
     */
    enlarge() {
      this.resizePage(this.pageScale * 1.2)
    },
    /**
     * 缩小
     */
    narrow() {
      this.resizePage(this.pageScale * 0.8)
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 页面编辑（元素操作控制）
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 移动页面中的元素
     * @param e
     * @param res 资源数据对象
     */
    movePageElement(e, res) {
      // 阻止上层事件
      e.stopPropagation()
      // 获取目标元素
      let oDiv = this.getTargetElement(e, 'res-node')
      if (!oDiv) {
        return
      }
      // 算出鼠标相对元素的位置
      let disX = e.clientX - oDiv.offsetLeft
      let disY = e.clientY - oDiv.offsetTop
      // 关闭目标元素的选择和拖拽事件
      e.target.onselectstart = function() {
        return false
      }
      e.target.ondragstart = function() {
        return false
      }
      // 注册文档鼠标移动事件
      document.onmousemove = (e) => {
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX
        let top = e.clientY - disY
        // 移动当前元素
        if (this.elePage.offsetWidth >= parseFloat(oDiv.style.width) + left && left >= 0) {
          oDiv.style.left = left + 'px'
          res.leftScale = left
          res.left = left / this.pageScale
        }
        if (this.elePage.offsetHeight >= parseFloat(oDiv.style.height) + top && top >= 0) {
          oDiv.style.top = top + 'px'
          res.top = top / this.pageScale
          res.topScale = top
        }
        res.edit = true
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    /**
     * 选中页面中的元素
     * @param e
     */
    selectedPageElement(e) {
      // 关闭所有选择状态
      this.closeSelectedStatus()
      // 获取目标元素
      let oDiv = this.getTargetElement(e, 'res-node')
      // 选中当前元素
      document.onclick = null
      setTimeout(() => {
        document.onclick = (e) => {
          if (e.target.id === 'digital-window' || e.target.id === 'digital-image' || e.target.parentNode.id === 'digital-window') {
            setTimeout(() => {
              this.closeSelectedStatus()
            }, 100)
            document.onclick = null
          }
        }
      }, 100)
      this.pageSelectedElement = oDiv
      oDiv.setAttribute('data-selected', true)
      this.$emit('onSelectedPageElement', this.pageSelectedElement)
    },
    /**
     * 取消选中页面中的元素
     */
    cancelSelectedPageElement() {
      if (this.pageSelectedElement) {
        this.pageSelectedElement.setAttribute('data-selected', false)
        this.pageSelectedElement = null
      }
      this.$emit('onSelectedPageElement', null)
    },
    /**
     * 调整页面中元素的尺寸《主要调整热区和链接》
     * @param e
     * @param type 类型，1：左上、2：上、3：右上、4：左、5：右、6：左下、7：下、8：右下
     * @param res 资源数据对象
     */
    resizePageElement(e, type, res) {
      // 阻止上层事件
      e.stopPropagation()
      // 获取目标元素
      let oDiv = this.getTargetElement(e, 'res-node')
      // 获取相关位置尺寸信息
      let pageX = e.pageX
      let pageY = e.pageY
      let oTop = parseFloat(oDiv.style.top)
      let oLeft = parseFloat(oDiv.style.left)
      let oWidth = oDiv.offsetWidth
      let oHeight = oDiv.offsetHeight
      // 关闭目标元素的选择和拖拽事件
      e.target.onselectstart = function() {
        return false
      }
      e.target.ondragstart = function() {
        return false
      }
      // 注册文档鼠标移动事件
      document.onmousemove = (e) => {
        let top = 0
        let left = 0
        let width = 0
        let height = 0
        let resizeLeft = () => {
          // 计算位置
          left = e.pageX - pageX
          width = pageX - e.pageX
          // 判断是否超界
          if (oLeft + left > 0 && oWidth + width >= 50) {
            oDiv.style.left = oLeft + left + 'px'
            oDiv.style.width = oWidth + width + 'px'
            res.leftScale = oLeft + left
            res.left = res.leftScale / this.pageScale
            res.widthScale = oWidth + width
            res.width = res.widthScale / this.pageScale
          }
        }
        let resizeRight = () => {
          // 计算位置
          width = e.pageX - pageX
          // 判断是否超界
          if (this.elePage.offsetWidth >= oLeft + oWidth + width && oWidth + width >= 50) {
            oDiv.style.width = oWidth + width + 'px'
            res.widthScale = oWidth + width
            res.width = res.widthScale / this.pageScale
          }
        }
        let resizeUp = () => {
          // 计算位置
          top = e.pageY - pageY
          height = pageY - e.pageY
          // 判断是否超界
          if (oTop + top > 0 && oHeight + height >= 50) {
            oDiv.style.top = oTop + top + 'px'
            oDiv.style.height = oHeight + height + 'px'
            res.topScale = oTop + top
            res.top = res.topScale / this.pageScale
            res.heightScale = oHeight + height
            res.height = res.heightScale / this.pageScale
          }
        }
        let resizeDown = () => {
          // 计算位置
          height = e.pageY - pageY
          // 判断是否超界
          if (this.elePage.offsetHeight >= oTop + oHeight + height && oHeight + height >= 50) {
            oDiv.style.height = oHeight + height + 'px'
            res.heightScale = oHeight + height
            res.height = res.heightScale / this.pageScale
          }
        }
        if (type === 1) {
          // 左上
          resizeLeft()
          resizeUp()
        } else if (type === 2) {
          // 上
          resizeUp()
        } else if (type === 3) {
          // 右上
          resizeRight()
          resizeUp()
        } else if (type === 4) {
          // 左
          resizeLeft()
        } else if (type === 5) {
          // 右
          resizeRight()
        } else if (type === 6) {
          // 左下
          resizeLeft()
          resizeDown()
        } else if (type === 7) {
          // 下
          resizeDown()
        } else if (type === 8) {
          // 右下
          resizeRight()
          resizeDown()
        }
        res.edit = true
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    /**
     * 删除页面中选中的元素
     */
    removePageSelectedElement(e) {
      e.stopPropagation()
      if (this.pageSelectedElement === null) {
        return
      }
      let dataIndex = this.pageSelectedElement.getAttribute('data-index')
      let type = this.pageSelectedElement.getAttribute('data-type')
      if (type === 'area' && this.editCoord.xiaoyangid) {
        this.deleteDialogOptions.tip = '当前区域已添加文章，是否删除？'
        this.$refs.deleteDialog.visible = true
      } else if ((type === 'video' || type === 'innerVideo') && this.page.resources[dataIndex].fileid) {
        this.deleteDialogOptions.tip = '已上传视频，是否删除？'
        this.$refs.deleteDialog.visible = true
      } else if (type === 'audio' && this.page.resources[dataIndex].fileid) {
        this.deleteDialogOptions.tip = '已上传音频，是否删除？'
        this.$refs.deleteDialog.visible = true
      } else if (type === 'link' && this.page.resources[dataIndex].href) {
        this.deleteDialogOptions.tip = '已添加链接地址，是否删除？'
        this.$refs.deleteDialog.visible = true
      } else if (type === 'picture' && this.page.resources[dataIndex].path) {
        this.deleteDialogOptions.tip = '已上传图片，是否删除？'
        this.$refs.deleteDialog.visible = true
      } else {
        this.deleteConfrim()
      }
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfrim() {
      // 删除页面中的元素
      if (this.pageSelectedElement.getAttribute('data-type') === 'area') {
        this.coordinates.splice(this.coordinates.indexOf(this.editCoord), 1)
        if (this.editCoord.xiaoyangid.toString().indexOf('new') < 0) {
          this.delResArray.push(this.editCoord)
        }
        this.editCoord = null
        this.$emit('deleteCoordinates')
      } else {
        let dataIndex = this.pageSelectedElement.getAttribute('data-index')
        this.elePage.removeChild(this.pageSelectedElement)
        // 清理页面中对应资源的序号
        let index = 0
        for (let a in this.elePage.children) {
          if (this.elePage.children.hasOwnProperty(a)) {
            let eleResNode = this.elePage.children[a]
            let eleResNodeClassName = eleResNode.className
            if (eleResNodeClassName === 'image' || eleResNodeClassName === 'loading' || eleResNodeClassName === 'res-node none' || eleResNodeClassName === 'res-node area') {
              continue
            }
            this.elePage.children[a].setAttribute('data-index', index)
            index++
          }
        }
        // 删除资源对应的数据
        if (this.page.resources[dataIndex].fileid) {
          this.delFileAttachIds.push(this.page.resources[dataIndex].fileid)
        }
        this.delResArray.push(this.page.resources[dataIndex])
        this.page.resources.splice(dataIndex, 1)
      }
    },
    /**
     * 选择功能项
     * @param e event
     * @param type 类型，audio：音频、video：视频、link：链接
     * @param continuity 连续操作，true：可以连续执行功能操作，false：仅可执行一次功能操作
     */
    selectTool(e, type, continuity) {
      // 没有权限时则提示去升级会员
      if (this.epaperRichMedia === 0) {
        this.$refs.memberDialog.visible = true
        return
      }
      // 取消所有选择状态
      this.closeSelectedStatus()
      // 隐藏所有热区
      this.hideAllArea()
      // 阻止上级事件
      e.stopPropagation()
      //
      if (type === 'audio') {
        this.addAudioStatus = !this.addAudioStatus
        this.addVideoStatus = false
        this.addLinkStatus = false
        this.addArticleStatus = false
        this.addPictureStatus = false
        if (this.addAudioStatus) {
          this.elePage.onclick = (e) => {
            e.stopPropagation()
          }
          this.elePage.onmouseup = (e) => {
            if (!this.addContinuityStatus) {
              this.addAudioStatus = false
              this.elePage.onmouseup = null
              document.onclick = null
            }
            if (e.target.id !== 'digital-image') {
              return
            }
            let res = {
              id: 0,
              type: 'audio',
              top: e.offsetY,
              left: e.offsetX,
              width: this.eleNone.offsetWidth * this.pageScale,
              height: this.eleNone.offsetHeight * this.pageScale,
              zindex: this.page.resources.length,
              resize: false,
              file: '',
              fileid: 0,
              path: '',
              controls: true,
              autoplay: true,
              loopplay: false,
              edit: true,
              btnStyle: 0,
              btnPath: '',
              btnAttachId: ''
            }
            this.page.resources.push(res)
            this.resCurrentScale(res)
            this.addResNode(this.page.resources.length - 1, res)
            this.showAllArea()
          }
        } else {
          this.elePage.onclick = null
          this.elePage.onmouseup = null
        }
        this.movePage()
      } else if (type === 'video') {
        this.addAudioStatus = false
        this.addVideoStatus = !this.addVideoStatus
        this.addLinkStatus = false
        this.addArticleStatus = false
        this.addPictureStatus = false
        if (this.addVideoStatus) {
          this.elePage.onclick = (e) => {
            e.stopPropagation()
          }
          this.elePage.onmouseup = (e) => {
            if (!this.addContinuityStatus) {
              this.addVideoStatus = false
              this.elePage.onmouseup = null
              document.onclick = null
            }
            if (e.target.id !== 'digital-image') {
              return
            }
            let res = {
              id: 0,
              type: 'video',
              top: e.offsetY,
              left: e.offsetX,
              width: this.eleNone.offsetWidth * this.pageScale,
              height: this.eleNone.offsetHeight * this.pageScale,
              zindex: this.page.resources.length,
              resize: false,
              file: '',
              fileid: 0,
              path: '',
              controls: true,
              autoplay: true,
              loopplay: false,
              edit: true,
              btnStyle: 0,
              btnPath: '',
              picturePath: '',
              btnAttachId: ''
            }
            this.page.resources.push(res)
            this.resCurrentScale(res)
            this.addResNode(this.page.resources.length - 1, res)
            this.showAllArea()
          }
        } else {
          this.elePage.onclick = null
          this.elePage.onmouseup = null
        }
        this.movePage()
      } else if (type === 'link' || type === 'picture' || type === 'innerVideo') {
        this.addAudioStatus = false
        this.addVideoStatus = type === 'innerVideo' ? !this.addVideoStatus : false
        this.addLinkStatus = type === 'link' ? !this.addLinkStatus : false
        this.addArticleStatus = false
        this.addPictureStatus = type === 'picture' ? !this.addPictureStatus : false
        if ((type === 'link' && this.addLinkStatus) || (type === 'picture' && this.addPictureStatus) || (type === 'innerVideo' && this.addVideoStatus)) {
          this.elePage.onclick = (e) => {
            e.stopPropagation()
          }
          this.elePage.onmousedown = (e) => {
            if (!this.addContinuityStatus) {
              this.addLinkStatus = false
              this.addPictureStatus = false
              this.addVideoStatus = false
              this.movePage()
              document.onclick = null
            }
            if (e.target.id !== 'digital-image') {
              return
            }
            let pageX = e.pageX
            let pageY = e.pageY
            let offsetX = e.offsetX
            let offsetY = e.offsetY
            let res = {
              id: 0,
              type: type,
              top: e.offsetY,
              left: e.offsetX,
              width: 5,
              height: 5,
              zindex: this.page.resources.length,
              resize: false,
              href: '',
              edit: true,
              btnStyle: 0,
              btnPath: '',
              btnAttachId: ''
            }
            if (type === 'innerVideo') {
              res.controls = true
              res.autoplay = false
              res.loopplay = false
            } else if (type === 'link') {
              res.linkType = 0
            }
            this.page.resources.push(res)
            this.resCurrentScale(res)
            let linkElement = this.addResNode(this.page.resources.length - 1, res)
            this.drawArea(linkElement, res, pageX, pageY, offsetX, offsetY)
          }
        } else {
          this.elePage.onclick = null
          this.movePage()
        }
        this.elePage.onmouseup = null
      } else if (type === 'area') {
        this.addAudioStatus = false
        this.addVideoStatus = false
        this.addLinkStatus = false
        this.addArticleStatus = !this.addArticleStatus
        this.addPictureStatus = false
        if (this.addArticleStatus) {
          this.elePage.onclick = (e) => {
            e.stopPropagation()
          }
          this.elePage.onmousedown = (e) => {
            if (!this.addContinuityStatus) {
              this.addArticleStatus = false
              this.movePage()
              document.onclick = null
            }
            if (e.target.id !== 'digital-image') {
              return
            }
            let pageX = e.pageX
            let pageY = e.pageY
            let offsetX = e.offsetX
            let offsetY = e.offsetY
            let res = {
              id: 0,
              type: type,
              top: e.offsetY,
              left: e.offsetX,
              width: 5,
              height: 5,
              zIndex: this.coordinates.length,
              resize: false,
              href: '',
              edit: true,
              xiaoyangid: 'new' + this.coordinates.length
            }
            this.resCurrentScale(res)
            let linkElement = this.addResNode(this.page.resources.length - 1, res)
            this.drawArea(linkElement, res, pageX, pageY, offsetX, offsetY, () => {
              linkElement.remove()
              this.coordinates.push(res)
              this.editCoord = null
            })
          }
        } else {
          this.elePage.onclick = null
          this.movePage()
        }
        this.elePage.onmouseup = null
      }
      // 用于处理点击其它地方后，取消所有选择状态与功能，并且同时处理一下连续处理状态
      if (this.addAudioStatus || this.addVideoStatus || this.addLinkStatus || this.addPictureStatus || this.addArticleStatus) {
        setTimeout(() => {
          document.onclick = () => {
            this.cancelSelectTool()
            this.showAllArea()
            document.onclick = null
          }
        }, 200)
        this.addContinuityStatus = continuity
      } else {
        this.addContinuityStatus = false
      }
    },
    /**
     * 绘制热区
     */
    drawArea(element, res, pageX, pageY, offsetX, offsetY, callback) {
      document.onmousemove = (e) => {
        let width = e.pageX - pageX
        let height = e.pageY - pageY
        if (this.elePage.offsetWidth >= width + offsetX) {
          element.style.width = width + 'px'
          res.widthScale = width
          res.width = width / this.pageScale
        }
        if (this.elePage.offsetHeight >= height + offsetY) {
          element.style.height = height + 'px'
          res.heightScale = height
          res.height = height / this.pageScale
        }
      }
      document.onmouseup = (e) => {
        let width = e.pageX - pageX
        let height = e.pageY - pageY
        if (this.elePage.offsetWidth >= width + offsetX) {
          element.style.width = width + 'px'
          res.widthScale = width
          res.width = width / this.pageScale
        }
        if (this.elePage.offsetHeight >= height + offsetY) {
          element.style.height = height + 'px'
          res.heightScale = height
          res.height = height / this.pageScale
        }
        if (width < this.eleNoneWidth || height < this.eleNoneHeight) {
          width = 100
          height = 100
          element.style.width = width + 'px'
          element.style.height = height + 'px'
          res.widthScale = width
          res.heightScale = height
          res.width = width / this.pageScale
          res.height = height / this.pageScale
        }
        document.onmousemove = null
        document.onmouseup = null
        this.showAllArea()
        if (callback) {
          callback(res)
        }
      }
    },
    /**
     * 取消选择功能项
     */
    cancelSelectTool() {
      this.addAudioStatus = false
      this.addVideoStatus = false
      this.addLinkStatus = false
      this.addPictureStatus = false
      this.addArticleStatus = false
      this.addContinuityStatus = false
      this.elePage.onclick = null
      this.elePage.onmouseup = null
      this.movePage()
    },
    hideAllArea() {
      for (let a in this.elePage.children) {
        if (this.elePage.children.hasOwnProperty(a)) {
          let ele = this.elePage.children[a]
          let type = ele.getAttribute('data-type')
          if (type === 'area') {
            ele.style.display = 'none'
          }
        }
      }
    },
    showAllArea() {
      for (let a in this.elePage.children) {
        if (this.elePage.children.hasOwnProperty(a)) {
          let ele = this.elePage.children[a]
          let type = ele.getAttribute('data-type')
          if (type === 'area') {
            ele.style.display = ''
          }
        }
      }
    },
    /**
     * 热区点击事件
     */
    areaClick(e, coord) {
      if (!this.editCoord || this.editCoord.xiaoyangid !== coord.xiaoyangid) {
        this.$emit('onAreaClick', coord)
        this.editCoord = coord
      }
      if (this.edit) {
        this.selectedPageElement(e)
        let div = this.getTargetElement(e, 'res-node')
        div.onmousedown = (event) => {
          this.movePageElement(event, coord)
        }
      }
    },
    /**
     *更换热区图层顺序
     */
    changLayout(e, index, type) {
      e.stopPropagation()
      let originIndex = this.coordinates[index].zIndex
      this.coordinates[index].edit = true
      switch (type) {
        case 'top':
          this.coordinates[index].zIndex = this.coordinates.length - 1
          for (let i = 0; i < this.coordinates.length; i++) {
            if (i !== index) {
              if (this.coordinates[i].zIndex > originIndex) {
                this.coordinates[i].zIndex = Math.max(this.coordinates[i].zIndex - 1, 0)
                this.coordinates[i].edit = true
              }
            }
          }
          break
        case 'bottom':
          this.coordinates[index].zIndex = 0
          for (let i = 0; i < this.coordinates.length; i++) {
            if (i !== index) {
              if (this.coordinates[i].zIndex < originIndex) {
                this.coordinates[i].zIndex = Math.max(this.coordinates[i].zIndex + 1, 0)
                this.coordinates[i].edit = true
              }
            }
          }
          break
        case 'up':
          this.coordinates[index].zIndex = Math.min(originIndex + 1, this.coordinates.length - 1)
          for (let i = 0; i < this.coordinates.length; i++) {
            if (i !== index) {
              if (this.coordinates[i].zIndex === originIndex + 1) {
                this.coordinates[i].zIndex = originIndex
                this.coordinates[i].edit = true
              }
            }
          }
          break
        case 'down':
          this.coordinates[index].zIndex = Math.max(originIndex - 1, 0)
          for (let i = 0; i < this.coordinates.length; i++) {
            if (i !== index) {
              if (this.coordinates[i].zIndex === originIndex - 1) {
                this.coordinates[i].zIndex = originIndex
                this.coordinates[i].edit = true
              }
            }
          }
          break
      }
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 页面编辑（元素属性控制）
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * 音频属性编辑
     */
    editAudio(e, res) {
      // 清理音频视频的上传动作的状态
      this.uploadStatus = false
      // 关闭所有选择状态
      this.closeSelectedStatus(1)
      // 设置正在编辑的数据
      this.editRes = res
      this.editConfig = {
        fileid: res.fileid,
        file: res.file,
        path: res.path,
        controls: res.controls,
        autoplay: res.autoplay,
        loopplay: res.loopplay,
        btnStyle: res.btnStyle,
        btnPath: res.btnPath,
        btnAttachId: res.btnAttachId
      }
      this.uploadAudioStatus = false
      this.uploadAudioProgress = 0
      // 显示窗口
      this.editStartWindow(e, 'audio')
    },
    editAudioClick(e) {
      e.stopPropagation()
    },
    editAudioCancel() {
      this.editRes = null
      this.editConfig = null
      let eleEditAudio = document.getElementById('edit-audio')
      if (eleEditAudio) {
        eleEditAudio.style.display = 'none'
      }
    },
    editAudioSubmit() {
      this.$refs.digitalAudioCustomImgRef.updateIcon()
      this.editRes.fileid = this.editConfig.fileid
      this.editRes.file = this.editConfig.file
      this.editRes.path = this.editConfig.path
      this.editRes.controls = this.editConfig.controls
      this.editRes.autoplay = this.editConfig.autoplay
      this.editRes.loopplay = this.editConfig.loopplay
      this.editRes.btnStyle = this.editConfig.btnStyle
      this.editRes.btnPath = this.$refs.digitalAudioCustomImgRef.currentIconObj.path
      this.editRes.btnAttachId = this.$refs.digitalAudioCustomImgRef.currentIconObj.id
      this.editRes.edit = true
      this.initResNodes()
      this.editAudioCancel()
    },
    /**
     * 视频属性编辑
     */
    editVideo(e, res) {
      // 清理音频视频的上传动作的状态
      this.uploadStatus = false
      // 关闭所有选择状态
      this.closeSelectedStatus(1)
      // 设置正在编辑的数据
      this.editRes = res
      this.editConfig = {
        fileid: res.fileid,
        vodFileId: res.vodFileId,
        file: res.file,
        path: res.path,
        controls: res.controls,
        autoplay: res.autoplay,
        loopplay: res.loopplay,
        btnStyle: res.btnStyle,
        btnPath: res.btnPath,
        btnAttachId: res.btnAttachId
      }
      this.uploadVideoStatus = false
      this.uploadVideoProgress = 0
      // 显示窗口
      this.editStartWindow(e, res.type)
    },
    editVideoClick(e) {
      e.stopPropagation()
    },
    editVideoCancel() {
      this.editRes = null
      this.editConfig = null
      let eleEditVideo = document.getElementById('edit-video')
      if (eleEditVideo) {
        eleEditVideo.style.display = 'none'
      }
    },
    editVideoSubmit() {
      this.$refs.digitalVideoCustomImgRef.updateIcon()
      this.editRes.fileid = this.editConfig.fileid
      this.editRes.vodFileId = this.editConfig.vodFileId
      this.editRes.file = this.editConfig.file
      this.editRes.path = this.editConfig.path
      this.editRes.controls = this.editConfig.controls
      this.editRes.autoplay = this.editConfig.autoplay
      this.editRes.loopplay = this.editConfig.loopplay
      this.editRes.btnStyle = this.editConfig.btnStyle
      this.editRes.btnPath = this.$refs.digitalVideoCustomImgRef.currentIconObj.path
      this.editRes.btnAttachId = this.$refs.digitalVideoCustomImgRef.currentIconObj.id
      this.editRes.edit = true
      // this.$refs.digitalVideoCustomImgRef.updateIcon()
      // this.$emit('update-obj', this.updateObj)
      this.initResNodes()
      this.editVideoCancel()
    },
    /**
     * 链接属性编辑
     */
    editLink(e, res) {
      // 清理音频视频的上传动作的状态
      this.uploadStatus = false
      // 关闭所有选择状态
      this.closeSelectedStatus(1)
      // 设置正在编辑的数据
      this.editRes = res
      this.editConfig = {
        href: res.linkType == 0 ? res.href : '',
        btnStyle: res.btnStyle,
        btnPath: res.btnPath,
        btnAttachId: res.btnAttachId,
        linkType: res.linkType,
        pageS: res.pageS,
        page: res.page
      }
      // 显示窗口
      this.editStartWindow(e, 'link')
    },
    editLinkClick(e) {
      e.stopPropagation()
    },
    editLinkCancel() {
      this.editRes = null
      this.editConfig = null
      let eleEditLink = document.getElementById('edit-link')
      if (eleEditLink) {
        eleEditLink.style.display = 'none'
      }
    },
    checkInput(value) {
      if (value < 1) {
        this.editConfig.page = 1
      } else if (value > this.totalPage) {
        this.editConfig.page = this.totalPage
      }
    },
    editLinkSubmit() {
      this.$refs.digitalCustomImgRef.updateIcon()
      this.editRes.linkType = this.editConfig.linkType
      this.editRes.pageS = this.editConfig.pageS
      this.editRes.page = this.editConfig.page
      if (this.editConfig.linkType === 0) {
        this.editRes.href = this.editConfig.href
      } else if (this.editConfig.pageS !== 'page') {
        this.editRes.href = this.editConfig.pageS
      } else {
        this.editRes.href = this.editConfig.page
      }
      this.editRes.btnStyle = this.editConfig.btnStyle
      this.editRes.btnPath = this.$refs.digitalCustomImgRef.currentIconObj.path
      this.editRes.btnAttachId = this.$refs.digitalCustomImgRef.currentIconObj.id
      this.editRes.edit = true
      console.log(this.updateObj)
      this.$emit('update-obj', this.updateObj)
      this.initResNodes()
      this.editLinkCancel()
    },
    /**
     * 开始启动编辑窗口
     */
    editStartWindow(e, type) {
      setTimeout(() => {
        switch (type) {
          case 'video':
            this.$refs.digitalVideoCustomImgRef.init('hotspot_video_icon')
            this.$store.commit('book/UPDATE_CLASSIFY', 'hotspot_video_icon')
            break
          case 'innerVideo':
            this.$refs.digitalVideoCustomImgRef.init('hotspot_video_cover')
            this.$store.commit('book/UPDATE_CLASSIFY', 'hotspot_video_cover')
            break
          case 'audio':
            this.$refs.digitalAudioCustomImgRef.init('hotspot_audio_icon')
            this.$store.commit('book/UPDATE_CLASSIFY', 'hotspot_audio_icon')
            break
          default: {
            this.$refs.digitalCustomImgRef.init('hotspot_hyperlink_icon')
            this.$store.commit('book/UPDATE_CLASSIFY', 'hotspot_hyperlink_icon')
          }
        }
        // 目标对象
        let target = this.getTargetElement(e, 'res-node')
        let top = parseFloat(this.elePage.style.top) + parseFloat(target.style.top)
        let left = parseFloat(this.elePage.style.left) + parseFloat(target.style.left) + parseFloat(target.offsetWidth)
        // 显示窗口
        let editLinkElement = document.getElementById('edit-' + (type === 'innerVideo' ? 'video' : type))
        editLinkElement.style.display = 'block'
        // 计算位置
        if (this.eleWindow.offsetHeight >= top + editLinkElement.offsetHeight) {
          editLinkElement.style.top = top + 'px'
        } else {
          editLinkElement.style.top = Math.max(this.eleWindow.offsetHeight - editLinkElement.offsetHeight - 5, -60) + 'px'
        }
        if (this.eleWindow.offsetWidth >= left + editLinkElement.offsetWidth) {
          editLinkElement.style.left = left + 10 + 'px'
        } else {
          editLinkElement.style.left = this.eleWindow.offsetWidth - editLinkElement.offsetWidth - 5 + 'px'
        }
        for (let a in document.body.children) {
          if (document.body.children.hasOwnProperty(a)) {
            if (document.body.children[a].nodeName === 'INPUT') {
              document.body.children[a].onclick = () => {
                this.uploadStatus = true
              }
            }
          }
        }
      }, 100)
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 上传图片、音频、视频相关方法
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    digitalUploadAudio() {
      if (this.uploadAudioStatus === false) {
        this.$refs.digitalUploadAudio.upload()
      } else {
        this.$alert(`正在上传音频中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateAudioState(state) {
      if (state === 'start') {
        this.uploadAudioStatus = true
      }
    },
    updateAudioProgress(percentage) {
      this.uploadAudioProgress = parseInt(percentage)
    },
    updateAudioSuccess(res) {
      // 恢复上传状态
      this.uploadAudioStatus = false
      this.editConfig.fileid = res.data.id
      this.editConfig.file = res.data.fileName
      this.editConfig.path = res.data.path

      // 回调上传成功的音频ID
      this.addFileAttachIds.push(res.data.id)
    },
    updateAudioComplete(file) {
      //
      this.uploadStatus = false
    },
    digitalUploadVideo() {
      if (this.uploadVideoStatus === false) {
        this.$refs.digitalUploadVideoTc.addMedia()
      } else {
        this.$alert(`正在上传视频中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateVideoTcState: function(state) {
      if (state === 'uploading') {
        this.uploadVideoStatus = true
      } else if (state === 'done') {
        this.uploadStatus = false
      }
    },
    updateVideoTcPercentage: function(percent) {
      //
      this.uploadVideoProgress = parseInt((percent * 100).toString())
    },
    uploadVideoTcSuccess: function(uploaderInfo) {
      // 上传至方正
      this.editConfig.vodFileId = uploaderInfo.fileId
      this.editConfig.file = uploaderInfo.title
      this.editConfig.path = uploaderInfo.mediaUrl
      setBook
        .addFileAttach({
          fileName: uploaderInfo.title,
          creator: uploaderInfo.creator,
          size: uploaderInfo.size,
          format: uploaderInfo.type,
          path: uploaderInfo.mediaUrl,
          fileType: 'video',
          module: this.isBook ? 'ebook' : 'epaper',
          vodFileId: uploaderInfo.fileId,
          status: 1,
          storageType: 'VOD'
        })
        .then(({ data, status }) => {
          if (status === 200 && data.status === 0) {
            // 恢复上传状态
            this.uploadVideoStatus = false
            this.editConfig.fileid = data.data?.id || uploaderInfo.fileId
            // 回调上传成功的音频ID
            this.addFileAttachIds.push(data.data.id)
          }
        })
    },
    uploadImg(res) {
      this.editRes = res
      if (this.uploadImageStatus === false) {
        this.$refs.digitalUploadImage.upload()
      } else {
        this.$alert(`正在上传图片中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateImageState(state) {
      if (state === 'start') {
        this.uploadImageStatus = true
      } else if (state === 'canceled') {
        this.uploadImageStatus = false
        this.editRes = null
      }
    },
    updateImageSuccess(res) {
      // 回调上传成功
      this.uploadImageStatus = false
      if (this.editRes.fileid) {
        this.delFileAttachIds.push(this.editRes.fileid)
      }
      this.editRes.fileid = res.data.id
      this.editRes.path = res.data.path
      this.editRes.edit = true
      this.initResNodes()
      this.editVideoCancel()
      this.addFileAttachIds.push(res.data.id)
    },
    updateImageComplete() {
      this.uploadImageStatus = false
    },
    updateImageError() {
      // 恢复上传状态
      setTimeout(() => {
        this.uploadImageStatus = false
      }, 100)
    },
    uploadVideoTcError: function() {
      this.$alert('上传失败', '提示', {
        confirmButtonText: '确定'
      })
    },
    updateVideoTcToSpace() {
      //
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 其它
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    resInitScale(res) {
      res.leftScale = res.left * this.pageScale
      res.topScale = res.top * this.pageScale
      res.widthScale = res.width * this.pageScale
      res.heightScale = res.height * this.pageScale
    },
    resCurrentScale(res) {
      res.leftScale = res.left
      res.topScale = res.top
      res.widthScale = res.width
      res.heightScale = res.height
      res.left = res.leftScale / this.pageScale
      res.top = res.topScale / this.pageScale
      res.width = res.widthScale / this.pageScale
      res.height = res.heightScale / this.pageScale
    },
    getTargetElement(e, className) {
      if (e.srcElement.className.indexOf(className) !== -1) {
        return e.srcElement
      }
      if (e.srcElement.parentNode.className.indexOf(className) !== -1) {
        return e.srcElement.parentNode
      }
      if (e.srcElement.parentNode.parentNode.className.indexOf(className) !== -1) {
        return e.srcElement.parentNode.parentNode
      }
      return null
    },
    /**
     * 关闭选中状态（包括：页面元素选中状态、页面元素属性窗口选中状态）
     * @param type 类型，undefined：关闭所有状态，1：关闭除页面元素选中状态外的其它所有选择状态
     */
    closeSelectedStatus(type) {
      if (this.uploadStatus) {
        return
      }
      if (type === undefined) {
        this.editAudioCancel()
        this.editVideoCancel()
        this.editLinkCancel()
        this.cancelSelectTool()
        this.cancelSelectedPageElement()
      } else if (type === 1) {
        this.editAudioCancel()
        this.editVideoCancel()
        this.editLinkCancel()
        this.cancelSelectTool()
      }
    },
    delConfig(val) {
      this.deletePic = val
      this.$emit('del-config', val)
    },
    updateObjFn(val) {
      this.updateObj = val
      this.editConfig.btnAttachId = val.id
      this.editConfig.btnPath = val.path
    },
    addConfigFn(val) {
      this.addConfig = val
      this.$emit('add-icon', val)
    }
  }
}
</script>
<style lang="scss">
.digital-window {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  position: absolute;
  z-index: 98;
  .page {
    position: absolute;
    margin: auto;
    text-align: center;
    font-size: 0;
    line-height: 0;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
      .text {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #ffffff;
        font-size: 24px;
        line-height: 24px;
      }
    }
    .image {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .link {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.2);
      overflow: hidden;
    }
    .innerVideo {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.2);
      overflow: hidden;
    }
    .picture {
      background-color: rgba(0, 0, 0, 0.2);
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .area {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.2);
      &:hover {
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    .res-node {
      position: absolute;
      img {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;
      }
      .resize {
        position: absolute;
        width: 6px;
        height: 6px;
        background: red;
        display: none;
      }
      .resize1 {
        top: 0;
        left: 0;
        cursor: nw-resize;
      }
      .resize2 {
        top: 0;
        left: 50%;
        margin-left: -3px;
        cursor: n-resize;
      }
      .resize3 {
        top: 0;
        right: 0;
        cursor: ne-resize;
      }
      .resize4 {
        top: 50%;
        left: 0;
        margin-top: -3px;
        cursor: e-resize;
      }
      .resize5 {
        top: 50%;
        right: 0;
        margin-top: -3px;
        cursor: e-resize;
      }
      .resize6 {
        bottom: 0;
        left: 0;
        cursor: ne-resize;
      }
      .resize7 {
        bottom: 0;
        left: 50%;
        margin-left: -3px;
        cursor: n-resize;
      }
      .resize8 {
        bottom: 0;
        right: 0;
        cursor: nw-resize;
      }
      .z-index_view {
        position: absolute;
        right: -35px;
        height: 100px;
        display: none;
        .z-index-buttons {
          height: 100%;
          width: 25px;
          display: flex;
          flex-direction: column;
          img {
            width: 20px;
            height: 21px;
            position: relative;
            margin-bottom: 5px;
          }
        }
        .view {
          width: 6px;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 6px;
            height: 6px;
            position: relative;
            margin-bottom: 2px;
            &.current {
              width: 8px;
              height: 8px;
            }
          }
        }
      }
    }
    .res-node[data-selected='true'] {
      .resize {
        display: block;
      }
      .z-index_view {
        display: flex;
      }
    }
  }
  .tools {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -80px;
    z-index: 9998;
    .box {
      .btn {
        margin: 14px;
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
      .selected {
        opacity: 0.5;
      }
      .continuity {
        opacity: 0.3;
      }
      .remove {
        opacity: 0;
      }
      .actived {
        opacity: 1;
      }
    }
  }
  .edit-audio,
  .edit-video,
  .edit-link {
    display: none;
    position: absolute;
    border: 1px solid #e3e3e3;
    box-shadow: 0 0 10px #000000;
    width: 362px;
    z-index: 9999;
    .title {
      background: #e3e3e3;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      line-height: 28px;
      .close {
        position: absolute;
        top: 0;
        right: 0;
        width: 28px;
        height: 28px;
        font-size: 0;
        cursor: pointer;
        img {
          width: 14px;
          height: 14px;
          margin-top: 7px;
        }
      }
    }
    .box {
      font-size: 12px;
      padding: 20px 30px;
      background: #ffffff;
      .loadPic {
        display: flex;
        .el-radio-group {
          margin-top: 0;
        }
      }
      .line {
        margin: 0 0 15px 0;
        overflow: hidden;
        .filename {
          float: left;
          border: 1px solid #e3e3e3;
          font-size: 12px;
          line-height: 22px;
          padding: 0 5px;
          width: 230px;
        }
        .uploadbtn {
          float: left;
          width: 70px;
          text-align: center;
          line-height: 18px;
          background: #df5813;
          padding: 3px 10px;
          border: none;
          border-radius: 0;
          color: #ffffff;
          cursor: pointer;
          .el-upload {
            &:focus {
              color: #ffffff;
            }
          }
          &:hover {
            background: #cd5112;
          }
          &:active {
            background: #bd4b10;
          }
        }
        .cancel {
          background: #999999;
          border: none;
          color: #ffffff;
          border-radius: 0;
          line-height: 24px;
          text-align: center;
          width: 70px;
          cursor: pointer;
          margin-right: 30px;
          &:hover {
            background: #888888;
          }
          &:active {
            background: #777777;
          }
        }
        .submit {
          background: #df5813;
          border: none;
          color: #ffffff;
          border-radius: 0;
          line-height: 24px;
          text-align: center;
          width: 70px;
          cursor: pointer;
          &:hover {
            background: #cd5112;
          }
          &:active {
            background: #bd4b10;
          }
        }
        &.path {
          margin-left: 15px;
          margin-top: 5px;
        }
        &.is-disabled {
          color: #c0c4cc;
          cursor: not-allowed;
          .href {
            background-color: #f5f7fa;
            border-color: #e4e7ed;
          }
        }
      }
      .line-button {
        padding-top: 20px;
        text-align: center;
      }
      .href {
        border: 1px solid #cccccc;
        padding: 5px;
        border-radius: 0;
        width: 280px;
        height: 5em;
        font-size: 12px;
        resize: none;
      }
    }
  }
  .edit-link {
    .title {
      position: relative;
    }
    .box {
      max-height: calc(100vh - 130px);
      overflow-y: auto;
      .line {
        margin: 15px 0;
      }
      .el-radio {
        .el-radio__label {
          font-size: 12px;
        }
      }
      .el-radio-group {
        margin-left: 15px;
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .el-radio:nth-child(4) {
          margin-right: 20px;
        }
        .el-radio {
          margin-bottom: 10px;
        }
        .el-input {
          display: inline;
          width: 150px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
.el-tooltip__popper {
  &.video-wrapper {
    padding: 0;
  }
  .video-btn-wrapper {
    width: 87px;
    padding: 0 10px;
    div {
      height: 26px;
      line-height: 26px;
      cursor: pointer;
      text-align: center;
    }
    :last-child {
      border-top: solid 1px #fff;
    }
  }
}
</style>
